"use client";

import React from "react";
import { SectionContentProps } from "../../types";
import EditableText from "../../core/EditableText";
import { GraduationCap, Award, BookOpen, Briefcase } from "lucide-react";

export default function CollegePrograms({
  content,
  onContentChange,
  isSelected,
}: SectionContentProps) {
  const fontFamily = content.fontFamily || "'Inter', sans-serif";
  const primaryColor = content.colorPalette?.primary || "#1E3A8A";

  const services = content.services || [
    { title: "Undergraduate", description: "Bachelor's degrees in Engineering, Business, Arts, and Sciences.", icon: "graduation" },
    { title: "Postgraduate", description: "Master's programs designed to advance your career with specialized knowledge.", icon: "certificate" },
    { title: "Doctoral Research", description: "Ph.D. programs pushing the boundaries of knowledge in collaboration.", icon: "research" },
    { title: "Professional Development", description: "Executive education and certification programs for professionals.", icon: "briefcase" },
  ];

  const iconMap: Record<string, any> = {
    graduation: <GraduationCap className="w-8 h-8 text-blue-600" />,
    certificate: <Award className="w-8 h-8 text-blue-600" />,
    research: <BookOpen className="w-8 h-8 text-blue-600" />,
    briefcase: <Briefcase className="w-8 h-8 text-blue-600" />,
  };

  return (
    <section
      className={`py-24 px-6 bg-slate-50 transition-all ${isSelected ? "ring-2 ring-blue-500 relative z-20" : ""}`}
      style={{ fontFamily }}
    >
      <div className="max-w-7xl mx-auto space-y-12">
        <div className="text-center space-y-4 max-w-xl mx-auto">
          <h2 className="text-3xl md:text-5xl font-extrabold text-slate-900 leading-tight">
            <EditableText
              value={content.title || "Academic Programs"}
              onChange={(val) => onContentChange?.({ ...content, title: val })}
              as="span"
            />
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {services.map((svc: any, idx: number) => (
            <div key={idx} className="bg-white p-8 rounded-2xl border border-slate-100 shadow-sm space-y-4 hover:shadow-md transition-all">
              <div className="w-14 h-14 rounded-xl bg-blue-50 flex items-center justify-center">
                {iconMap[svc.icon] || <GraduationCap className="w-8 h-8 text-blue-600" />}
              </div>
              <h3 className="text-xl font-bold text-slate-900">{svc.title}</h3>
              <p className="text-sm text-slate-600 leading-relaxed">{svc.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
